/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import SectionTitle from '@components/uyirnokkam/UymSectionTitle';
import config from '@config';

/* Services */
/* Styles */

/**
 * Renders the Card Zigzag Group 2 Card component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} lang - Language for page
 * @param {string} region - Region for page
 * @returns {ReactElement} CardZigzagGroup Card component
 */

const UymCardZigzagGroup = ({ sectionContent, region, lang, section }) => {
  const ZigZagSection = sectionContent[1];
  return (
    <Box w={'100%'}>
      <Box width={'91.66%'} h="100%" mx="auto">
        <Box
          pt={{ base: '10px', md: '10px' }}
          pb={{ base: '20px', md: '30px' }}
          mb={{base:'15px', md:'20px'}}
        >
          <SectionTitle titleObj={sectionContent[0]} lang={lang} />
        </Box>
        <Box
          mx={{
            base: '1%',
            md: ZigZagSection ? '0%' : '2%',
            lg: ZigZagSection ? '0%' : '10%',
          }}
        >
          {ZigZagSection?.cards?.map((data, index) => {
            return (
              <Box display={'flex'} justifyContent={'center'}>
                <CardInfo
                  section={section}
                  data={data}
                  sectionContent={sectionContent}
                  region={region}
                  lang={lang}
                  index={index}
                  key={index}
                />
              </Box>
            );
          })}
        </Box>
      </Box>
      <Box
        maxW={'1157px'}
        w={{ base: '90%' }}
        m={{ base: '0 auto 50px auto', md: '0 auto 50px auto' }}
        fontFamily="MuktaMlalar"
        pl={{ base: '0', lg: '15px' }}
      >
        <Box
          w="100%"
          bgColor="#FFFBED"
          color="#28231E"
          borderLeft="8px solid #F3AE58"
          padding="0"
          lineHeight="27px"
          fontWeight={'500'}
          fontSize="16px"
          pl={{ base: '0px', md: '20px' }}
          fontFamily="MuktaMlalar"
          height={{base:'173px', md:'auto'}}
          borderTopRightRadius={'5px'}
          borderBottomEndRadius={'5px'}
        >
          <Box
            className="info-text"
            padding={{ base: '9px 20px 8px 20px', md: '10px 0' }}
          >
            <StructuredTextParser
              str={render(sectionContent[2]?.body)}
              region={region}
              lang={lang}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const CardInfo = ({
  // sectionContent,
  // section,
  data,
  region,
  lang,
  index,
}) => {
  const settings = {
    dots: true,
    autoplay: true,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,

    customPaging: function () {
      return (
        <Text
          cursor="pointer"
          display="inline-block"
          w="12px"
          h="12px"
          bgColor="#fff"
          borderRadius="50%"
        ></Text>
      );
    },
  };

  const isEvenIndex = index % 2 == 0;
  const flexDirection = isEvenIndex ? 'row' : 'row-reverse';
  const textAlign = isEvenIndex ? 'right' : 'left';
  const float = isEvenIndex ? 'left' : 'right';

  return (
    <Box
      display="flex"
      justifyContent="center"
      key={nanoid()}
      mb={{ base: 12, md: '4.5em' }}
      flexDirection={{ base: '', md: flexDirection }}
      position={{ base: '', md: 'relative' }}
      alignItems={'center'}
      maxW={{ base: '100%', md: '1109px' }}
      className="singleCard"
      flexDir={{base:'column'}}
    >
      <Box
        className="visual_section_mobile"
        w={{ base: '284px', md: '520px' }}
        flex={{ base: '', md: '0 0 520px' }}
        textAlign={{
          base: 'center',
          sm: 'left',
        }}
        display={{base:'block', md:'none'}}
        height={{
          base: 'auto',
          md: '375px',
        }}
        ml={{ base: '0', md: textAlign == 'right' ? '-160px' : '0' }}
        mr={{ base: '0', md: textAlign == 'right' ? '0px' : '-160px' }}
        pr={{ base: '0', md: flexDirection == 'row' ? '60px' : '0px' }}
        pl={{ base: '0', md: flexDirection != 'row' ? '60px' : '0px' }}
        bgImage={{
          base: '',
          md:
            textAlign == 'right'
              ? `url('${config.imgPath}/d/46272/1733667553-uy_zigzag_bg_right.png')`
              : `url('${config.imgPath}/d/46272/1733667556-uy_zigzag_bg_left.png')`,
        }}
        backgroundPosition={textAlign == 'right' ? 'top right' : 'top left'}
        justifyItems={{ base: 'center' }}
      >
        <LazyLoadImageComponent
          alt={data.thumbnails[0]?.alt}
          title={data.thumbnails[0]?.alt}
          textAlign="center"
          float={{ base: 'none', md: float }}
          src={data.thumbnails[0]?.url}
          height={{
            base: 'auto',
            md: '100%',
          }}
        />
      </Box>
      <Box
        className="slider description"
        w={{ base: '100%', lg: '755px' }}
        flex={{ base: '', md: '0 0 755px' }}
        color={'black'}
        textAlign={{ base: 'left', md: 'right' }}
        height="auto"
        margin={'0'}
        marginTop={{base:'-90px', md:'0'}}
        bg={'#D4F0AC'}
        borderRadius={'5px'}
        position={'relative'}
        zIndex={'-1'}
        minH={{ base: 'auto', md: '446px' }}
        alignContent={'center'}
        pr={{ base: '0px', md: flexDirection == 'row' ? '180px' : '25px' }}
        pl={{ base: '0px', md: flexDirection == 'row' ? '25px' : '180px' }}
        paddingTop={{base:'110px', md:'0'}}
        paddingBottom={{base:'24px', md:'0'}}
      >
        <Box
          as="h3"
          fontFamily={'MuktaMlalar'}
          fontSize={{ base: '26px', md: '28px' }}
          fontWeight="600"
          textAlign={'left'}
          color="#02026B"
          lineHeight={{ base: '1.61', md: '100%' }}
          mb={{ base: '0', md: '5%' }}
          mt={{ base: '0', md: '0' }}
          pl="15px"
        >
          {data.title}
        </Box>
        <Box
          as="h4"
          fontSize={{base:'16px', md:'20px'}}
          pl="15px"
          color={'#000000'}
          fontFamily={'MuktaMlalar'}
          textAlign={'left'}
          className="structuredText"
        >
          <StructuredTextParser
            str={render(data.description)}
            region={region}
            lang={lang}
            textAlign={'left'}
          />
        </Box>
      </Box>
      <Box
        className="visual_section"
        w={{ base: '284px', md: '520px' }}
        flex={{ base: '', md: '0 0 520px' }}
        textAlign={{
          base: 'center',
          sm: 'left',
        }}
        display={{base:'none', md:'block'}}
        bg="#ffffff"
        height={{
          base: 'auto',
          md: '375px',
        }}
        ml={{ base: '0', md: textAlign == 'right' ? '-160px' : '0' }}
        mr={{ base: '0', md: textAlign == 'right' ? '0px' : '-160px' }}
        pr={{ base: '0', md: flexDirection == 'row' ? '85px' : '0px' }}
        pl={{ base: '0', md: flexDirection != 'row' ? '85px' : '0px' }}
        bgImage={{
          base: '',
          md:
            textAlign == 'right'
              ? `url('${config.imgPath}/d/46272/1733667553-uy_zigzag_bg_right.png')`
              : `url('${config.imgPath}/d/46272/1733667556-uy_zigzag_bg_left.png')`,
        }}
        backgroundRepeat={'no-repeat'}
        backgroundPosition={textAlign == 'right' ? 'top right' : 'top left'}
        justifyItems={{ base: 'center' }}
      >
        <LazyLoadImageComponent
          alt={data.thumbnails[0]?.alt}
          title={data.thumbnails[0]?.alt}
          textAlign="center"
          float={{ base: 'none', md: float }}
          src={data.thumbnails[0]?.url}
          height={{
            base: 'auto',
            md: '100%',
          }}
        />
      </Box>
      <style jsx global>
        {`
          .structuredText p {
            color: #000000;
            font-size: 20px;
            line-height: 32px;
          }
          .structuredText a {
            color: #cf4824;
          }
          .structuredText a:hover {
            border-bottom: 1px solid #cf4824;
          }
          .info-text p {
            font-size: 20px;
            line-height: 34px;
            font-weight: 600;
            padding-bottom:12px;
            letter-spacing: -1px;
          }
          .info-text p strong {
            font-weight: 600;
          }
          @media (max-width: 768px) {
            .structuredText p {
              font-size: 16px;
              line-height: 26px;
            }
            .info-text p {
              font-size: 18px;
              font-weight: 600;
              padding-bottom:5px;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default UymCardZigzagGroup;
